import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

import axiosClient from "../../api/axios";

const WhyChooseUs = () => {
  const [homeWhyUs, setHomeWhyUs] = useState(null);
  const [loadingHomeWhyUs, setLoadingHomeWhyUs] = useState(true);

    useEffect(() => {
    const fetchHomeWhyUs = async () => {
      try {
        const response = await axiosClient.get(`/api/home-why-us/`);
        setHomeWhyUs(response.data.data);
      } catch (error) {
        console.error("Failed to fetch study:", error);
      } finally {
        setLoadingHomeWhyUs(false);
      }
    };

    fetchHomeWhyUs();
  }, []);


  if (loadingHomeWhyUs) {
    return (
      <section
        className="promo-section ptb-100"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }

  return (
    <>
      <section className="promo-section ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-5">
                <h2>{homeWhyUs?.title}</h2>
                <p className="lead">{homeWhyUs?.description}</p>
              </div>
            </div>
          </div>
          <div className="row equal">
            {homeWhyUs?.sections?.map((data) => (
              <div key={data?.id} className="col-md-4 col-lg-4">
                <div className="single-promo single-promo-hover single-promo-1 rounded text-center white-bg p-5 h-100">
                  <div className="circle-icon mb-5">
                    <span className={`${data?.icon} text-white`}></span>
                  </div>
                  <h5>{data?.title}</h5>
                  <p>{data?.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link className="btn solid-btn" to={"/our-values"}>
              {homeWhyUs?.button}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;
